<template>
  
  <span>
    {{ value }}
    <span v-if="pricedByPriceList" title="Sale Order was posted automatically using Price List">
      &nbsp;&nbsp;&nbsp;
      <v-icon size="16" color="primary">mdi-tag-text-outline</v-icon>
    </span>
  </span>
</template>

<script>
import { computed } from '@vue/reactivity';

export default {
  setup(props) {
    const value = computed(() => props.params?.value);
    const pricedByPriceList = computed(() => props.params?.data?.pricedByPriceList === true);

    const onEdit = () => {
      const startEditingParams = {
        rowIndex: props.params.rowIndex,
        colKey: props.params.column.getId(),
      };
      props.params.api.startEditingCell(startEditingParams);
    };

    return {
      value,
      onEdit,
      pricedByPriceList,
    };
  },
};
</script>
